/**
 * Utility functions for filter management in the Grading Portal.
 */

/**
 * Converts a filter value to an array.
 * Handles undefined values by returning an empty array.
 */
export function toArray<T>(value: T[] | undefined): T[] {
    return value ?? [];
}

/**
 * Normalizes an array filter value for storage.
 * Returns undefined if empty, or the array if it has values.
 */
export function normalizeArrayFilterValue<T>(values: T[]): T[] | undefined {
    return values.length === 0 ? undefined : values;
}
